import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { BaseModalComponent } from 'src/app/core/base-modal.componant';
import { SessionService } from 'src/app/shared/services/session.service';
import { LeagueMemberService } from 'src/app/simulator-booking/services/league-member.service';
import { League } from 'src/app/simulator-booking/models/league';

@Component({
    selector: 'create-league-member-modal',
    templateUrl: './create-league-member-modal.component.html',
    styleUrl: './create-league-member-modal.component.scss',
    standalone: false
})
export class CreateLeagueMemberModalComponent extends BaseModalComponent implements OnInit {

    public league: League;
    public form = new FormGroup({
        firstName: new FormControl('', {
            validators: Validators.required
        }),
        lastName: new FormControl('', {
            validators: Validators.required
        }),
        email: new FormControl('', {
            validators: [Validators.email, Validators.required]
        }),
        leagueId: new FormControl('', {
            validators: Validators.required
        }),
        organizationId: new FormControl('', {
            validators: Validators.required
        }),
        createdBy: new FormControl()
    });

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: League,
        private sessionService: SessionService,
        private leagueMemberService: LeagueMemberService,
        public dialogRef: MatDialogRef<CreateLeagueMemberModalComponent>
    ) {
        super();
        this.league = data;
    }

    ngOnInit(): void {
        this.form.get('leagueId').setValue(this.league.id);
        this.form.get('organizationId').setValue(this.sessionService.getUser().organizationId);
        this.form.get('createdBy').setValue(this.sessionService.getUserId());
    }

    submit({ value, valid }): void {
        if (valid) {
            this.isLoading = true;
            this.leagueMemberService.create(value).subscribe({
                next: (result) => {
                    if (result !== null && result !== undefined) {
                        this.dialogRef.close("save");
                    }
                },
                error: (error) => {
                    console.error('Error creating league member:', error);
                    this.setErrorV2(error, this.form);
                    this.isLoading = false;
                },
                complete: () => this.isLoading = false
            });
        }
    }
}

